import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ClickZonelessModule } from '@core/directives/zoneless/click/click-zoneless.module';
import { TranslateUiModule } from '@core/translation/translate-ui.module';
import { TabsTileComponent } from './tabs-tile.component';

@NgModule({
  declarations: [TabsTileComponent],
  exports: [TabsTileComponent],
  imports: [CommonModule, RouterModule, TranslateUiModule, ClickZonelessModule]
})
export class TabsTileModule {}
